import { useQueryClient } from '@tanstack/react-query';
import { useCallback, useSyncExternalStore } from 'react';
import { guestSessionStore } from './guest-session';
import type { GuestSession } from './guest-session';
import { staffSessionStore } from './staff-session';
import type { StaffSession } from './staff-session';

export function useGuestSession(): GuestSession | null {
  return useSyncExternalStore(guestSessionStore.subscribe, guestSessionStore.get);
}

export function useStaffSession(): StaffSession | null {
  return useSyncExternalStore(staffSessionStore.subscribe, staffSessionStore.get);
}

/** Ends the staff session and drops every cached server response, so the next user starts clean. */
export function useSignOutStaff(): () => void {
  const queryClient = useQueryClient();
  return useCallback(() => {
    staffSessionStore.clear('signed-out');
    queryClient.clear();
  }, [queryClient]);
}

/** Forgets the guest session on this device (for example, "not my table"). */
export function useResetGuest(): () => void {
  const queryClient = useQueryClient();
  return useCallback(() => {
    guestSessionStore.clear('signed-out');
    queryClient.clear();
  }, [queryClient]);
}
